import { useState, useMemo } from 'react';
import { IconChart, IconChevronDown, IconChevronUp } from './Icons';

export default function StatsDashboard({ locations, governorates, activeGov, onSelectGov }) {
  const [collapsed, setCollapsed] = useState(false);

  const counts = useMemo(() => {
    const byGov = {};
    let active = 0, inactive = 0;
    for (const l of locations) {
      const g = l.governorate || 'unknown';
      byGov[g] = (byGov[g] || 0) + 1;
      if ((l.status || 'active') === 'active') active++; else inactive++;
    }
    const sorted = governorates
      .map(g => ({ ...g, count: byGov[g.key] || 0 }))
      .filter(g => g.count > 0)
      .sort((a, b) => b.count - a.count);
    return { sorted, total: locations.length, active, inactive, max: sorted[0]?.count || 1 };
  }, [locations, governorates]);

  return (
    <div className={`stats-dashboard ${collapsed ? 'collapsed' : ''}`}>
      <button className="stats-head" onClick={() => setCollapsed(c => !c)} aria-expanded={!collapsed}>
        <span className="stats-head-title">
          <IconChart size={16} className="stats-head-icon" />
          <span>المواقع حسب المحافظة</span>
        </span>
        {collapsed ? <IconChevronDown size={16} /> : <IconChevronUp size={16} />}
      </button>

      {!collapsed && (
        <>
          <div className="stats-summary">
            <div className="stats-summary-item">
              <span className="stats-summary-label">المجموع</span>
              <span className="stats-summary-val total">{counts.total}</span>
            </div>
            <div className="stats-summary-item">
              <span className="stats-summary-label">نشط</span>
              <span className="stats-summary-val ok">{counts.active}</span>
            </div>
            {counts.inactive > 0 && (
              <div className="stats-summary-item">
                <span className="stats-summary-label">موقوف</span>
                <span className="stats-summary-val warn">{counts.inactive}</span>
              </div>
            )}
          </div>

          <div className="stats-list" role="listbox">
            <button className={`stats-item ${!activeGov ? 'is-active' : ''}`} onClick={() => onSelectGov?.(null)} role="option" aria-selected={!activeGov}>
              <span className="stats-item-name">الكل</span>
              <span className="stats-bar"><span className="stats-bar-fill" style={{ width: '100%' }} /></span>
              <span className="stats-count">{counts.total}</span>
            </button>
            {counts.sorted.map(g => (
              <button key={g.key}
                      className={`stats-item ${activeGov === g.key ? 'is-active' : ''}`}
                      onClick={() => onSelectGov?.(g.key)}
                      role="option"
                      aria-selected={activeGov === g.key}>
                <span className="stats-item-name">{g.name_ar}</span>
                <span className="stats-bar"><span className="stats-bar-fill" style={{ width: `${(g.count / counts.max) * 100}%` }} /></span>
                <span className="stats-count">{g.count}</span>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
